export class LoginFormModel {
    constructor(
        public login: string = '',
        public senha: string = ''
    ){}
}